import laravel1 from "../assets/Javascript1.png";
import laravel2 from "../assets/laravel2.jpg";
import laravel3 from "../assets/laravel3.png";
import javascript1 from "../assets/Javascript1.png";
import javascript2 from "../assets/Javascript2.png";
import javascript3 from "../assets/Javascript3.jpg";
import php1 from "../assets/php1.jpg";
import php2 from "../assets/php2.jpg";
import php3 from "../assets/php3.jpg";
import react1 from "../assets/react1.jpg";
import react2 from "../assets/react2.png";
import react3 from "../assets/react3.webp";
import redux1 from "../assets/redux1.png";
import redux2 from "../assets/redux2.jpg";
import redux3 from "../assets/redux3.avif";

const blogs = [
    {
        id: 1,
        title: "How I develop applications with Laravel.",
        img: laravel2,
        categoryId: 1,
        authorId: 1,
        create_at: "2022-08-20 11:05:25",
    },
    {
        id: 2,
        title: "Javascript is a client side language.",
        img: javascript1,
        categoryId: 2,
        authorId: 3,
        create_at: "2022-08-22 10:05:25",
    },
    {
        id: 3,
        title: "Learn php and create beautiful website.",
        img: php1,
        categoryId: 5,
        authorId: 1,
        create_at: "2020-08-20 9:05:25",
    },
    {
        id: 4,
        title: "PHP is server side scripting language.",
        img: php2,
        categoryId: 5,
        authorId: 2,
        create_at: "2020-08-20 9:05:25",
    },
    {
        id: 5,
        title: "Event Sourcing in Laravel.",
        img: laravel3,
        categoryId: 1,
        authorId: 2,
        create_at: "2022-08-21 10:05:25",
    },
    {
        id: 6,
        title: "Learn javascript and create your own website.",
        img: javascript2,
        categoryId: 2,
        authorId: 1,
        create_at: "2022-08-22 10:05:25",
    },
    {
        id: 7,
        title: "JavaScript was invented by Brendan Eich in 1995.",
        img: javascript3,
        categoryId: 2,
        authorId: 1,
        create_at: "2022-08-22 10:05:25",
    },
    {
        id: 8,
        title: "Redux was created by Dan Abramov around June 2015.",
        img: redux1,
        categoryId: 3,
        authorId: 3,
        create_at: "2022-08-21 12:05:25",
    },
    {
        id: 9,
        title: "React is a free and open-source front-end JavaScript library.",
        img: react2,
        categoryId: 4,
        authorId: 4,
        create_at: "2022-08-22 6:05:25",
    },
    {
        id: 10,
        title: "Redux got popular very quickly because of its simplicity.",
        img: redux3,
        categoryId: 3,
        authorId: 1,
        create_at: "2022-08-21 7:05:25",
    },
    {
        id: 11,
        title: "React was created by Jordan Walke, a software engineer at Facebook.",
        img: react1,
        categoryId: 4,
        authorId: 3,
        create_at: "2022-08-21 6:05:25",
    },
    {
        id: 12,

        title: "Redux is an open source javascript library.",
        img: redux2,
        categoryId: 3,
        authorId: 4,
        create_at: "2022-08-21 8:05:25",
    },
    {
        id: 13,
        title: "React makes it painless to create interactive UI's.",
        img: react3,
        categoryId: 4,
        authorId: 2,
        create_at: "2022-08-22 9:05:25",
    },
    {
        id: 14,
        title: "PHP is a general-purpose scripting language geared toward web development.",
        img: php3,
        categoryId: 5,
        authorId: 4,
        create_at: "2022-08-22 11:05:25",
    },
    {
        id: 15,
        title: "Laravel is a free and open-source PHP web framework, created by Taylor Otwell.",
        img: laravel1,
        categoryId: 1,
        authorId: 2,
        create_at: "2022-08-21 9:05:25",
    },
];

export default blogs;
